import axios from 'axios';
//import '@/filters';

//import users from '@/users';
//import enquiriesTools from '@/employee/enquiries/enquiriesTools';
//import moment from 'moment';
//import Vue from 'vue';

export default {
  name: 'CustomerCustomFields',
    components: {    
      LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
      EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
      CustomFieldsComp: require('@/components/customFields.vue').default,
  },
  //mixins: [users, enquiriesTools],
  props: {
    keyParam: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      customFields: { items: [] },
      isLoading: true,
    }
  },
  mounted() {
    if (this.type === 'customer')
      this.getCustomerCustomFields();
    else if (this.type === 'property')
      this.getPropertyCustomFields();
  },
  methods: {
    getCustomerCustomFields() {
      this.isLoading = true;
      axios.get('/Enquiries2/GetCustomerCustomFields?account=' + this.keyParam )
        .then(response => {
          //console.log("resp", response)
          if (response.status == 200) {
            this.customFields.items = response.data;
            this.customFields.items.forEach(c => c.isReadonly = true);
          }
          else
            this.noAccountFound();
        })
        .catch(e => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPropertyCustomFields() {
      this.isLoading = true;
      axios.get('/Enquiries/GetPropertyCustomFields?account=' + this.keyParam )
        .then(response => {
          //console.log("resp", response)
          if (response.status == 200) {
            this.customFields.items = response.data;
            this.customFields.items.forEach(c => c.isReadonly = true);
          }
          else
            this.noAccountFound();
        })
        .catch(e => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
 
  }
}

